// extracted by mini-css-extract-plugin
export default {"iconDefault":"Saving_iconDefault__A+VPm"};